export const formatUrlTrailing = (url: string) =>
	url.match(/\/$/) ? url : url + '/';
